import React from "react"
import ReactDatePicker from "react-datepicker";
import moment from 'moment'
import { ThemeSetup } from '../../themes/ThemeSetup';
import t from '../../i18n/I18n';
import './DatePicker.css';
import "react-datepicker/dist/react-datepicker.css";
import KeyboardShortcuts from "../../keyboard-shortcuts/KeyboardShortcuts";
import KeydownConfig from "../../keyboard-shortcuts/KeydownConfig";
import { KeyCode } from "../../util/Constants";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];

class DatePicker extends React.Component {
    static defaultProps = {
        placeholder: '',
        format: 'MM/DD/YYYY',
        className: 'editMetadata'
    };
    
    constructor(props) {
        super(props);
        this.state = {
            startDate: props.selected ? new Date(props.selected) : null,
            endDate: null,
            showMonth: false,
            showYear: false,
        }
        this.calendar = React.createRef();
    }

    closeCalendar = () => {
      this.setState({
        showMonth : false,
        showYear : false
      })
      this.calendar.current.setOpen(false);
    }

    hideAndShowCalendar = () => {
      this.calendar.current.setOpen(!this.calendar.current.isCalendarOpen())
    }

    parseDateToString = (startDate, endDate) => {
        startDate =  moment(startDate).format(this.props.format);
        endDate = moment(endDate).format(this.props.format);
        return `${startDate} - ${endDate}`
    }

    onDateChange = (date) => {
        if (!(this.state.showMonth || this.state.showYear)) {
            if(this.props.range)  {
                const [startDate, endDate] = date;
                this.setState({ startDate: startDate, endDate: endDate })
                if (startDate && endDate) {
                    this.props.onChange(this.parseDateToString(startDate, endDate));
                    this.closeCalendar();
                }
            } else {
                this.setState({ startDate: date })
                this.props.onChange(moment(date));
            }
        }

        if (this.state.showYear) {
            this.setState({ showYear: false })
        }
        if (this.state.showMonth && !this.state.showYear) {
            this.setState({ showMonth: false })
        }
    }

    customHeader = (props) => {
        const {
            date,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
            increaseYear,
            decreaseYear
        } = props;

        let next = increaseMonth
        let prev = decreaseMonth
        if (this.state.showMonth) {
            next = increaseYear
            prev = decreaseYear
        }
        return <div className='customHeader'>
            <button className='prev single-navigate' onClick={prev} disabled={prevMonthButtonDisabled} />
            <div>
                {!this.state.showMonth &&
                    <button className='navigation' onClick={() => this.setState({ showMonth: true })}>{MONTHS[date.getMonth()]}</button>
                }
                <button className='navigation' onClick={() => this.setState({ showYear: true })}>{date.getFullYear()}</button>
            </div>
            <button className='next single-navigate' onClick={next} disabled={nextMonthButtonDisabled} />
        </div>
    }

    clearDate = () => {
        this.setState({ startDate : null, endDate : null })
        this.closeCalendar();
        this.props.onChange(null)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.willUpdateFromOutside && new Date(props.selected).valueOf() != new Date(state.startDate).valueOf()) {
          return {
            ...state, startDate: new Date(props.selected)
          }
        } else {
          return state;
        }
      }
    

    todayClick = () => {
        if(this.props.range) {
            this.props.onChange(this.parseDateToString(new Date(), new Date()));
            this.setState({ startDate : new Date(), endDate : new Date() })
        } else {
          this.setState({ selected:  new Date() })
            this.props.onChange(moment(new Date()))
        }
        this.closeCalendar();
    }

    addKeyBoardEventOnCalendarOpen = ()=>{
        KeyboardShortcuts.add(new KeydownConfig(('DATE_PICKER'),this.onKeyDown, [KeyCode.ESCAPE]))

    }
    removeKeyBoardEventOnCalendarClose = ()=>{
        KeyboardShortcuts.remove('DATE_PICKER');
    }

    onKeyDown = (e: KeyboardEvent) => {
        this.closeCalendar();
    }

    onCalendarOpen = () => {
        if(this.props.bottomBar) {
            this.addKeyBoardEventOnCalendarOpen();
            const reactDatepicker = document.getElementsByClassName('react-datepicker')[0];
            const clearButton = document.createElement('button');
            const todayButton = document.createElement('button');
            reactDatepicker.appendChild(todayButton);
            reactDatepicker.appendChild(clearButton);

            todayButton.innerText=t('TODAY');
            todayButton.classList.add('today-button');
            todayButton.addEventListener('click', this.todayClick)

            clearButton.innerText=t('CLEAR');
            clearButton.classList.add('clear-button');
            clearButton.addEventListener('click', this.clearDate);
        }
    }

    render() {
        let props;
        if (this.props.range) {
            props = {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                selectsRange: true,
            }
        }

        const customInputProps = this.props.range ? {
            customValue : this.props.value
        } : null;

        const renderCustomHeader = !this.state.showYear ? {
            renderCustomHeader : this.customHeader
        } : null;
        return <div name='DateRangePicker' id='DateRangePicker' className={`DateRangePicker ${this.props.bottomBar ? 'DatePickerWitBottomBar' : null}`} ref={this.dateref} >
            <ReactDatePicker
                customInput={
                    <CustomInput
                        showCalendarIcon={this.props.showCalendarIcon} 
                        range={this.props.range} 
                        format={this.props.format} 
                        className={this.props.className}
                        hideAndShowCalendar = {this.hideAndShowCalendar}
                        {...customInputProps}
                    />}
                popperPlacement={'top-start'}
                selected={this.state.startDate}
                onChange={this.onDateChange}
                ref={this.calendar}
                placeholderText={this.props.placeholder}
                showYearPicker={this.state.showYear}
                showMonthYearPicker={this.state.showMonth}
                onCalendarClose={this.removeKeyBoardEventOnCalendarClose}
                shouldCloseOnSelect={this.props.range ? false : !(this.state.showYear || this.state.showMonth)}
                {...renderCustomHeader}
                onCalendarOpen={this.onCalendarOpen}
                disabledKeyboardNavigation
                {...props}
            />
            </div>
    }
}


export class CustomInput extends React.Component {
  render() {
    const { customValue, hideAndShowCalendar, placeholder, value, className, range, showCalendarIcon } = this.props;
    let dateString;
    if (range) {
      dateString = customValue;
      if (dateString) {
        const dates = dateString.split(' - ');
        dateString = dates[0] == dates[1] ? dates[0] : dateString;
      }
    } else {
      dateString = value ? moment(value).format(this.props.format) : '';
    }
    return (
      <div className={className}>
        <div className="sideBySideInput inputText" onClick={hideAndShowCalendar}>
          {dateString ? dateString : placeholder}
        </div>
        {showCalendarIcon ? <img onClick={hideAndShowCalendar} src={ThemeSetup.getImageURL('calendar.svg')} /> : null}
      </div>
    );
  }
}

export default DatePicker
